import {
  Grid,
  Theme,
  Typography,
  WithStyles,
  withStyles
} from '@material-ui/core'
import { FC } from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { sendPasswordResetCode } from '../../../../actions/users'
import { MuiClasses } from '../../../../types'
import { StateInterface } from '../../../../types/states'
import { bindSubmitActionToPromise } from '../../../../utils/forms'
import RequestPasswordResetForm from './RequestPasswordResetForm'

const styles = ({ spacing }: Theme) => ({
  form: {
    padding: spacing(),
    maxWidth: 600,
    margin: '50px auto'
  }
})

interface RequestPasswordResetProps extends WithTranslation, WithStyles {
  classes: MuiClasses
  doSendPasswordResetCode: (arg: any) => any
  isPasswordResetCodeSent: boolean
}

const RequestPasswordReset: FC<RequestPasswordResetProps> = ({
  classes,
  t,
  doSendPasswordResetCode,
  isPasswordResetCodeSent
}) => (
  <Grid
    container
    direction='column'
    alignItems='center'
    className={classes.form}
  >
    <Typography variant='h3' gutterBottom>
      {t('forgotPassword.title')}
    </Typography>
    {!isPasswordResetCodeSent && (
      <RequestPasswordResetForm sendResetCode={doSendPasswordResetCode} t={t} />
    )}
    {isPasswordResetCodeSent && (
      <Typography variant='body2' gutterBottom>
        <span color='red'>{t('forgotPassword.instructionsSent')}</span>
      </Typography>
    )}
  </Grid>
)

const mapStateToProps = ({ users }: StateInterface) => ({
  isPasswordResetCodeSent: users.isPasswordResetCodeSent
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  doSendPasswordResetCode: bindSubmitActionToPromise(
    dispatch,
    sendPasswordResetCode
  )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(RequestPasswordReset as any)))
